import type { InterviewStatus, OfferStatus, ProposalStatus } from '../../data/clientEngagementMock';

export function proposalStatusLabel(s: ProposalStatus): string {
  const m: Record<ProposalStatus, string> = {
    waiting_feedback: 'Wacht op jouw feedback',
    shortlisted: 'Op shortlist',
    rejected: 'Niet passend',
    more_info_requested: 'Meer info gevraagd',
    interview_requested: 'Interview aangevraagd',
    on_hold: 'Later beoordelen',
  };
  return m[s] || s;
}

export function interviewStatusLabel(s: InterviewStatus): string {
  const m: Record<InterviewStatus, string> = {
    planned: 'Gepland',
    completed: 'Afgerond',
    feedback_needed: 'Feedback nodig',
    reschedule_requested: 'Verplaatsing gevraagd',
  };
  return m[s] || s;
}

export function interviewTypeLabel(t: 'online' | 'locatie' | 'telefonisch'): string {
  const m = { online: 'Online', locatie: 'Op locatie', telefonisch: 'Telefonisch' };
  return m[t];
}

export function offerStatusLabel(s: OfferStatus): string {
  const m: Record<OfferStatus, string> = {
    draft: 'Concept',
    sent: 'Verstuurd',
    negotiating: 'In onderhandeling',
    accepted: 'Geaccepteerd',
    risk: 'Risico gemarkeerd',
  };
  return m[s] || s;
}

export function formatNlDateTime(iso: string): string {
  try {
    return new Date(iso).toLocaleString('nl-NL', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

export function formatNlDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('nl-NL', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  } catch {
    return iso;
  }
}

/** Agenda-groep: volledige datum met weekdag (NL). */
export function formatNlAgendaDayHeading(isoDate: string): string {
  try {
    const d = new Date(isoDate + 'T12:00:00');
    return d.toLocaleDateString('nl-NL', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  } catch {
    return isoDate;
  }
}
